"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _config = require("./config.js");

var Config = _interopRequireWildcard(_config);

var _webBiLogger = require("@wix/web-bi-logger");

var _webBiLogger2 = _interopRequireDefault(_webBiLogger);

var _iframeAppBiLogger = require("@wix/iframe-app-bi-logger");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("es6-shim");


var createBIEvent = function createBIEvent(event) {
  var id = event.id,
      fields = event.fields;

  return {
    evid: id,
    fields: _lodash2.default.fromPairs(_lodash2.default.map(_lodash2.default.union([], Config.commonFields, fields), function (field) {
      return [field.name, field.type];
    }))
  };
};

var BIClass = function BIClass() {
  var _this = this;

  (0, _classCallCheck3.default)(this, BIClass);

  this.init = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Translate camelCase into snake_case
    var siteId = params.siteId,
        biToken = params.biToken,
        ownerId = params.ownerId,
        instanceId = params.instanceId,
        metasiteId = params.metasiteId,
        organizationId = params.organizationId,
        _params$useIframeLogg = params.useIframeLogger,
        useIframeLogger = _params$useIframeLogg === undefined ? false : _params$useIframeLogg,
        rest = (0, _objectWithoutProperties3.default)(params, ["siteId", "biToken", "ownerId", "instanceId", "metasiteId", "organizationId", "useIframeLogger"]);

    if (siteId) rest.site_id = siteId;
    if (biToken) rest.bi_token = biToken;
    if (ownerId) rest.ownerId = ownerId;
    if (instanceId) rest.instance_id = instanceId;
    if (metasiteId) rest.msid = metasiteId;
    if (organizationId) rest.organization_id = organizationId;

    _this.defaultParams = rest;

    var loggerFactory = void 0;
    if (useIframeLogger) {
      // we are using try/catch because of foodbook exception.
      // https://app.asana.com/0/1179575937101122/1186808590336915
      try {
        loggerFactory = (0, _iframeAppBiLogger.iframeAppBiLoggerFactory)(window.Wix, { endpoint: "rest" });
      } catch (e) {
        // mocking the logger to do nothing in case we can not create iframe logger
        loggerFactory = {
          updateDefaults: function updateDefaults() {
            return this;
          },
          logger: function logger() {
            return this;
          },
          log: function log() {
            return this;
          }
        };
      }
    } else {
      loggerFactory = _webBiLogger2.default.factory({ endpoint: "rest" });
    }
    _this._loggerFactory = loggerFactory;
    _this.webBI = _this._createWebBI();
    /**
     * TODO:
     * Native BI should be remove once restaurants-management-app is fully deprecated
     */
    _this.nativeBIConfig = (0, _extends4.default)({
      defaults: _lodash2.default.omit(_this.defaultParams, "organization_id"),
      events: _lodash2.default.reduce(Config.events, function (rc, val, key) {
        return (0, _extends4.default)({}, rc, (0, _defineProperty3.default)({}, key, { evid: val.id }));
      }, {}),
      isTest: false,
      path: "rest-native",
      debug: false
    }, _this.nativeBIConfig);

    if (_this.mobileBILogger) {
      _this.nativeBI = _this.mobileBILogger(_this.nativeBIConfig);
    } else {
      _this.nativeBI = null;
    }
  };

  this._createWebBI = function () {
    var additionalDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (_this._loggerFactory) {
      return _this._loggerFactory.updateDefaults((0, _extends4.default)({}, _this.defaultParams, additionalDefaults, {
        src: 61
      })).logger();
    }
  };

  this.updateWebBIDefaults = function (defaults) {
    var newWebBI = _this._createWebBI(defaults);
    if (newWebBI) [_this.webBI = newWebBI];
  };

  this.event = function (event) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!event) {
      return _promise2.default.reject("BiUtils exception: event not found! Params were: " + params);
    }

    var cacheBuster = "" + Math.floor(Math.random() * 1000) + Date.now();
    var newParams = _lodash2.default.reduce(params, function (rc, val, key) {
      rc[key] = typeof val === "number" && event.fields[key] === "string" ? val.toString() : val;
      return rc;
    }, { _c: cacheBuster });

    try {
      if (!event.evid) throw new Error("evid must be provided");
      if (_this.nativeBI) {
        return _this.nativeBI.log((0, _extends4.default)({ evid: event.evid }, newParams));
      } else {
        newParams = (0, _extends4.default)({}, _this.defaultParams, newParams);
        _this.webBI.log((0, _extends4.default)({ evid: event.evid }, newParams));
      }
    } catch (e) {
      return _promise2.default.reject(e);
    }
    return _promise2.default.resolve();
  };

  this.useNative = function (mobileBILogger) {
    var nativeBIConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _this.mobileBILogger = mobileBILogger;
    if (_this.nativeBIConfig) {
      _this.nativeBI = mobileBILogger((0, _extends4.default)({}, _this.nativeBIConfig, nativeBIConfig));
    } else {
      _this.nativeBIConfig = nativeBIConfig;
    }
  };

  this.EVENTS = _lodash2.default.zipObject(_lodash2.default.keys(Config.events), _lodash2.default.map(Config.events, createBIEvent));
  this._actualEvent = this._webEvent;
};

exports.default = new BIClass();